import type { Video } from '~publish/legacy/composer/composer/entities/factories'

import { PlayIcon } from '../../../../assets/twitter'
import { VideoPlayer } from '../../../Common/VideoPlayer'

import styles from './AttachmentVideo.module.css'

import type { JSX } from 'react'

const AttachmentVideo = ({ video }: { video: Video }): JSX.Element => {
  return (
    <VideoPlayer
      video={video}
      playIcon={<PlayIcon size="large" />}
      className={styles.videoPlayer}
    />
  )
}

export { AttachmentVideo }
